'use strict'

module.exports = function (ngModule) {
  ngModule.service('PgApi', ["$http", "$q", "$log", "$httpParamSerializerJQLike", function ($http, $q, $log, $httpParamSerializerJQLike) {
    this.reqResetPwd = function (email, region) {
      return $q(function (resolve, reject) {
        $http({
          method: 'PUT',
          url: '/api/req_reset_pwd',
          data: {
            'user_email': email,
            'region': region
          }
        }).then(function success (data) {
          $log.debug('reqResetPwd', data)
          resolve('Send confirm email, please check your email')
        }, function error (err) {
          $log.debug('reqResetPwd:ERROR', err)
          if (err.status === 409) {
            reject({
              msg: 'It looks like you are using your Facebook credentials to log in. To change your Facebook password go to your settings page at facebook.com',
              status: err.status
            })
          } else if (_.has(err, 'data.code')) {
            reject({
              msg: err.data.code.toUpperCase(),
              status: err.status
            })
          } else if (_.has(err, 'data.errorMessage')) {
            reject({
              msg: err.data.errorMessage,
              status: err.status
            })
          } else {
            reject({ msg: err.toString(), status: err.status })
          }
        })
      })
    },
    this.doResetPassword = function (token, newPassword, opts) {
      var payloadData = (!_.isEmpty(opts))
        ? _.assign({}, { reset_password: newPassword }, opts)
        : { reset_password: newPassword }
      $log.debug('api:doResetPassword', token, newPassword, opts, payloadData)
      return $http({
        method: 'PUT',
        url: '/api/do_reset_pwd/' + token,
        data: $httpParamSerializerJQLike(payloadData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    },
    this.sendToTracker = function (input) {
      return $q(function (resolve, reject) {
        $http({
          method: 'POST',
          url: '/tracker',
          data: input
        }).success(function (data) {
          resolve(data)
        }).error(function (data, status) {
          $log.debug(data)
          reject(data)
        })
      })
    }
  }])
}



//////////////////
// WEBPACK FOOTER
// ./js/services/api.js
// module id = 56
// module chunks = 0